module.exports = require("assert");


//////////////////
// WEBPACK FOOTER
// external "assert"
// module id = 20
// module chunks = 0